import script from "./TradeButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradeButton.vue?vue&type=script&setup=true&lang=ts"

import "./TradeButton.vue?vue&type=style&index=0&id=4b5f77fa&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5f77fa"]])

export default __exports__